/**
 * Determines the country code (ISO 3166-1 alpha-2) from a timezone string
 * @param {string} timezone - The timezone string (e.g., "Pacific/Auckland", "Australia/Sydney")
 * @returns {string} - Country code ("nz", "au", or null if unknown)
 */
export const getCountryFromTimezone = (timezone) => {
  // Handle null, undefined, or non-string types
  if (!timezone || typeof timezone !== 'string') return null;
  
  const tz = timezone.toLowerCase().trim();
  
  // Handle empty string after trim
  if (!tz) return null;
  
  // New Zealand timezones - check specific patterns first for accuracy
  if (
    tz.includes('pacific/auckland') ||
    tz.includes('pacific/wellington') ||
    tz.includes('/nz') ||
    tz === 'new zealand' ||
    tz === 'nz'
  ) {
    return 'nz';
  }
  
  // Check for 'nz' substring (timezone names are standardized, so false positives are unlikely)
  // This catches patterns like "NZ/Auckland" or similar
  if (tz.includes('nz')) {
    return 'nz';
  }
  
  // Australian timezones - check specific patterns first
  if (
    tz.includes('australia/') ||
    tz.includes('/au') ||
    (tz.includes('australia') && !tz.includes('indian'))
  ) {
    return 'au';
  }
  
  // Default to null if unknown (caller should handle fallback)
  return null;
};

